<template>
  <div v-if="tabShow">
    <div v-if="!pageIndex">

      <el-form-item :label="$t('message.table.templateName') + ':'">

        <div style="color:#606266">{{ pageId[0] }}</div>
      </el-form-item>
      <el-form-item :label="$t('message.table.selectStartOrEnd') + ':'" required>
        <el-select v-model="time" :placeholder="$t('message.placeholder.select')" style="width:50%" @change="reqChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- label="是否拷贝相关人员:" -->
      <el-form-item :label="$t('message.table.copyRelate') + ':'">
        <el-select v-model="value" :placeholder="$t('message.placeholder.search')" @change="upCopyId" style="width:50%">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </div>
    <div v-for="item in columnInfo" :key="item.id" :model="pageData">

      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 1">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input maxlength="300" :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
            @input="upInput(item.index)" @blur='emitInput(item.index)'></el-input>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="item.uiType == 3" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-cascader clearable v-if="item.listType == 2" :style="input_width" v-model="pageData[item.index]"
            :options="item.listEntrie" :show-all-levels="false" :props="{ checkStrictly: true }"
            @change="upCascadeList(item.index)">
          </el-cascader>
          <el-select v-else-if="item.id == 1092004" v-model="pageData[item.index]"
            :placeholder="$t('message.placeholder.select')" :style="input_width" :disabled="!item.editable"
            @change="upSimpleList(item.index)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.id">
            </el-option>
          </el-select>
          <el-select v-else v-model="pageData[item.index]" clearable :placeholder="$t('message.placeholder.select')"
            :style="input_width" :disabled="!item.editable || item.id == 1051017" @change="upSimpleList(item.index)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="item.uiType == 6" :required="item.required" :class="{ del: item.id == delDate }">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-date-picker v-if="item.id == time" @change="upDateTime(item.index)" :style="input_width"
            v-model="pageData[item.index]" :picker-options="pickerOptions" type="date"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
          <el-date-picker v-else-if="item.id != 1051001 && item.id != 1051002" @change="upDateTime(item.index)"
            :style="input_width" v-model="pageData[item.index]" type="date"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
        </el-form-item>
      </div>

      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 7">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>

          <el-input :style="input_width" v-model="pageData[item.index]" @input="upInput(item.index, item.id)"
            @blur='emitInput(item.index, item.id)' :disabled="!item.editable || item.id == 1051003">
          </el-input>

          <!-- <el-input  maxlength="240" :style="input_width" :disabled="!item.editable" @input="upInput(item.index,item.id)" @blur='emitInput(item.index,item.id)'>
          </el-input> -->

        </el-form-item>
      </div>
      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 10">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input :style="input_width" v-model="pageData[item.index]" @input='costInput(item.index)'
            @blur="upCurrency(item.index)" :readonly='item.id == 1051046 || item.id == 1051047'
            :disabled="!item.editable">
            <!-- <span style="margin:0 5px" slot="prefix" >{{"￥ " + " "}} </span> -->
            <span style="margin:0 5px" slot="append">{{ "￥ " + $t('message.table.currency') }} </span>
            <!-- <el-select
              v-model="currencyIdList[item.index]"
              slot="append"
              :placeholder="$t('message.placeholder.select')"
              @change="upCurrencyId(item.index)"
              :disabled="!item.editable"
            >
              <el-option
                v-for="items in item.listEntrie"
                :label="items.name"
                :value="items.id"
                :key="items.id"
              ></el-option>
            </el-select> -->
          </el-input>
        </el-form-item>
      </div>
    </div>

  </div>
</template>

<script>
import Spe from "./special.vue";
import axios from "axios";
export default {
  data() {
    return {
      titleName: "",
      tabShow: true,
      pageInfo: {},
      columnInfo: [],
      column: [],
      ColPage: "false",
      isClearable: true,
      searchMf: "",
      dateList: [],
      list: [],
      casMultiData: [],
      time: 1051001,
      delDate: 1051002,
      options: [
        {
          value: 1051001,
          label: this.$t('message.title.startDate'),
        },
        {
          value: 1051002,
          label: this.$t('message.title.endDate'),
        },
      ],
      options2: [{
        value: 1,
        label: this.$t('message.table.yes'),
      }, {
        value: 0,
        label: this.$t('message.table.no'),
      }],
      value: '',
      pickerOptions: {
        // disabledDate(time) {
        //   // console.log(time);
        //   return time.getDay() == 0 || time.getDay() == 6
        // },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      },

      reqList: [],
      pageData: [],
      input_width: {
        width: "50%",
      },

      budgetedCosts: [],
      actualCosts: [],
      currencyIdList: [],


      multiList: [],
      cascadeList: [],
      cascadeMultiList: [],
      multi: { multiple: true },
      resetNum: "",
      nameId: "",
      baseId: "",
      basicData: {},
      subData: {},
      isReq: true,
    };
  },
  components: {
    Spe,
  },
  props: ["page", "pageIndex", "reset", "totalData", 'pageId'],
  methods: {
    getColumn() {
      console.log(this.page);
      if (!this.page.column.ids.length) {
        this.columnInfo = [];
        this.tabShow = false;
        return;
      }

      this.budgetedCosts = [];
      this.actualCosts = [];
      // console.log(this.page.val);
      let valArr = this.deepCopy(this.page.val);
      // console.log(valArr);
      this.baseId = parseInt(valArr.objClass.toString().substr(0, 3));
      let column = this.getNewData(this.page.column);
      const costList = [1051036, 1051037, 1051038, 1051039, 1051040, 1051041, 1051042, 1051043, 1051044, 1051045, 1051046, 1051047]
      column.map((i, e) => (i.index = e));

      const arr = valArr.cells;
      // console.log(898979799497978,arr);
      const simpleUiType = [1, 2, 6, 7, 8, 10];
      const speSipList = [1051009];

      column.map((i, e) => {
        if (simpleUiType.includes(i.uiType)) {
          this.pageData[i.index] = arr[e].val;
          this.subData[i.id] = this.pageData[i.index];
          // console.log(this.subData['1051003']);
        }

        if (i.uiType == 3) {
          if (speSipList.includes(parseInt(i.id))) {
            // console.log(arr[e]);
            i.listEntrie = [{ name: arr[e].val, id: arr[e].id }];
          }
          if (i.id == 1051010 || i.id == 1051011) {
            i.listEntrie = this.totalData.userList.map((i) => {
              return { name: i.loginId, id: i.id };
            });
          }
          if (i.id == 1051030) {
            i.listEntrie = this.totalData.workflowList;
          }
          this.pageData[i.index] = arr[e].id == -1 ? "" : arr[e].id;
          this.subData[i.id] = this.pageData[i.index];
          if (i.listType == 2) {
            this.cascadeList.push(parseInt(i.id));
            // console.log(this.cascadeList);
            if (arr[e].id != -1) {
              this.pageData[i.index] = this.getParentIdList(
                i.listEntrie,
                parseInt(arr[e].id)
              );
              this.subData[i.id] = this.pageData[i.index];
            }
          }
        }
        if (i.uiType == 4) {
          if (i.listType == 2) {
            this.cascadeMultiList.push(parseInt(i.id));
            let m = arr[e].ids;
            this.pageData[i.index] = m
              ? m.split(";").map((j) => {
                return this.getParentIdList(i.listEntrie, parseInt(j));
              })
              : "";
            this.casMultiData[i.index] = this.pageData[i.index];
            this.subData[i.id] = this.pageData[i.index];
          }
          if (i.listType == 1 || !i.listType) {
            this.multiList.push(parseInt(i.id));
            let m = arr[e].ids;
            this.pageData[i.index] = m
              ? m.split(";").map((i) => {
                if (i) {
                  return parseInt(i);
                }
              })
              : "";
            this.subData[i.id] = this.pageData[i.index];
          }
        }

        if (i.uiType == 10) {
          // console.log(i);
          // this.pageData[i.index] = arr[e].realVal;
          // this.currencyIdList[i.index] =  JSON.stringify(arr[e].currencyCode) == "{}" ? '' : arr[e].currencyCode +''
          costList.filter((_, e) => (e % 2)).includes(parseInt(i.id)) && this.budgetedCosts.push(i.index);
          costList.filter((_, e) => !(e % 2)).includes(parseInt(i.id)) && this.actualCosts.push(i.index);
          // i.val = arr[e];
          // this.subData[i.id] = this.pageData[i.index];
        }
      });

      this.columnInfo = column.filter((i) => i.required);
      this.getReqList(this.time);

      column.filter(i => {
        if (this.reqList.includes(i.id)) {
          this.basicData[i.id] = this.pageData[i.index]
        }
      })

      this.subData = this.formatList(this.basicData);
      this.getDefaultValues(column);
      this.columnInfo = column.filter((i) => i.required);
      this.upData();
    },
    getReqList(e) {
      let list = this.columnInfo.filter((i) => i.required).map((i) => i.id);
      let m = this.options.findIndex((i) => i.value == e);
      this.delDate = parseInt(this.options[1 - m].value);
      list.splice(list.indexOf(this.delDate), 1);
      this.reqList = list;
      return this.delDate
    },
    reqChange(e) {
      let n = this.getReqList(e);
      this.pageData[this.page.column.ids.findIndex(i => i == n)] = ''

      let arr = Object.keys(this.subData)
      arr.map((i) => {
        if (i == n) {
          delete this.subData[i]
        }
      })
      this.upData();
    },

    formatList(data) {
      for (let e in data) {
        let i = data[e];
        if (this.multiList.includes(parseInt(e))) {
          // console.log(222);
          if (i) {
            // console.log(i);
            if (i.length > 1) {
              // console.log(i);
              let n = i.map(Number);
              data[e] = n.join(";");
            } else {
              data[e] = i[0];
            }
            // console.log(data[e]);
          } else {
            data[e] = "";
          }
        }
        if (this.cascadeList.includes(parseInt(e))) {
          // console.log(222);
          if (i) {
            if (i.length > 1) {
              data[e] = i.pop();
            } else {
              data[e] = i[0];
            }
          } else {
            data[e] = "";
          }
        }
        if (this.cascadeMultiList.includes(parseInt(e))) {
          if (i) {
            let m = data[e].map((j) => {
              // console.log(j);
              return j.pop();
            });
            data[e] = m.join(";");
            // }).join(';')
          } else {
            data[e] = "";
          }
        }
      }
      return data;
    },
    upInput(i) {
      this.$forceUpdate();
    },
    upCopyId() {
      this.upData();
    },
    emitInput(i, id) {
      let n = this.pageData[i];
      let m = id || this.getAttrId(i);
      this.subData[m] = !n ? '' : n.trim();
      this.upData();
    },

    getAttrIndex(id) {
      const index = this.columnInfo.findIndex((item) => item.id == id);
      return index
    },
    getAttrId(index) {
      const id = this.columnInfo.find((item) => item.index == index).id
      return id
    },

    upDateTime(i) {
      //this.subData[i] = this.pageData[i];
      const m = this.getAttrId(i)

      console.log(i, m);
      if (m == 1051001 || m == 1051002) {
        let t = this.pageData[i];
        this.pageData[i] = new Date(Date.parse(t.toDateString()) + -t.getTimezoneOffset() * 60 * 1000);
        if (m == 1051001) {
          const dualIndex = this.getAttrIndex('1051003');
          this.subData['1051002'] = this.countEndDate(parseInt(this.pageData[dualIndex]), this.pageData[i])
        }
        else {
          const templist = this.calendarList
          const n1 = templist.filter(i => i.exceptionType == 1).map(i => i.exceptionDate.split('T')[0])
          const n2 = templist.filter(i => i.exceptionType == 2).map(i => i.exceptionDate.split('T')[0])

          let e = Date.parse(this.pageData[i]);
          while (n1.includes(this.getLocalTime(e)) || ([0, 6].includes(new Date(e).getDay()) && !n2.includes(this.getLocalTime(e)))) {
            e -= 24 * 60 * 60 * 1000;
          }
          const dualIndex = this.getAttrIndex('1051003');
          let n = parseInt(this.pageData[dualIndex]);
          for (let i = 0; i < n - 1; i++) {
            do {
              e -= 24 * 60 * 60 * 1000;
            } while (n1.includes(this.getLocalTime(e)) || ([0, 6].includes(new Date(e).getDay()) && !n2.includes(this.getLocalTime(e))))
          }
          this.subData['1051001'] = new Date(e)
        }
      }
      this.subData[m] = this.pageData[i];
      this.upData();
    },
    upCascadeList(i) {
      this.$forceUpdate();
      // console.log(this.pageData[i]);
      let n = this.pageData[i];
      let m = this.getAttrId(i)
      this.subData[m] = n[n.length - 1] || "";
      this.upData();
    },

    upSimpleList(i) {
      this.$forceUpdate();
      let n = this.pageData[i];
      let m = this.getAttrId(i)
      this.subData[m] = n || "";
      this.upData();
    },
    upMultiList(i) {
      this.$forceUpdate();
      let n = this.pageData[i];
      let m = this.getAttrId(i)
      this.subData[m] = this.arrSort(n);
      this.upData();
    },
    upCascadeMultiList(i) {
      let n = this.deepCopy(this.casMultiData[i]);
      let m = this.getAttrId(i)
      this.subData[m] = n.length > 0 ? this.arrSort(n.map(this.arrLast)) : "";
      this.upData();
    },
    upCurrency(i) {
      let n = parseFloat(this.pageData[i]).toFixed(2);
      n = isNaN(n) ? '' : n
      const m = this.getAttrId(i);
      this.$set(this.pageData, i, n)
      this.subData[m] = n;
      // if (!this.currencyIdList[i]) {
      //   const currencyId = this.columnInfo.find(item =>item.index == i).val.currencyId;
      //   const defaultCurrency = this.columnInfo.find(item =>item.index == i).listEntrie[0].id;
      //   this.currencyIdList[i] = defaultCurrency;
      //   this.subData[currencyId] =  defaultCurrency;
      // }
      this.upData()
    },
    upCurrencyId(i) {
      const currencyId = this.getAttrId(i) + '_01';
      console.log(this.currencyIdList[i]);
      this.subData[currencyId] = this.currencyIdList[i];
      this.$forceUpdate();
      this.upData();
    },
    costInput(i) {
      // // console.log(i);
      let costConvolution = (arr) => {
        let sum = 0;
        for (let i = 0, j = arr.length - 1; i < j; i++) {
          sum += parseInt(this.pageData[arr[i]]) || 0;
        }
        this.pageData[arr[arr.length - 1]] = sum;
      };
      this.budgetedCosts.includes(i) && costConvolution(this.budgetedCosts)
      this.actualCosts.includes(i) && costConvolution(this.actualCosts)

      // this.pageData[i]=this.pageData[i].replace(/[^0-9.]/g,'');
      let n = this.pageData[i];
      this.pageData[i] = n.replace(/[^0-9.]/g, '');
      if (!Number(n)) {
        this.pageData[i] = '';
      }

      this.$forceUpdate();
      this.emitInput(i);
    },
    arrLast(n) {
      n = n.length > 0 ? n[n.length - 1] : "";
      return n;
    },
    arrSort(n) {
      n = n.length > 0 ? n.sort((a, b) => a - b).join(";") : "";
      return n;
    },
    getDefaultValues(data) {
      // if (i.defaultValue) {
      //     this.pageData[i.index] = i.defaultValue;
      //     console.log(i.defaultValue,i.index);
      //   }
      const arr = data.filter((i) => !!i.defaultValue);
      arr.map((i) => {
        console.log(i);
        // const e = this.columnInfo.find(item =>item.index == i.index).id;
        const e = i.id;
        this.subData[e] = this.pageData[i.index];
        if (i.uiType == 3 && i.listType == 2) {
          let val_ = i.defaultValue.split(",");
          val_ = val_[0].split(";");
          let searchVal_ = val_[val_.length - 1];
          this.subData[i.id] = searchVal_;
          this.pageData[i.index] = this.getParentIdListByPid(
            i.listEntrie,
            searchVal_
          );
          // this.subData[i.id] = this.pageData[i.index]
        } else if (i.uiType == 4) {
          if (i.listType == 2) {
            let Val_ = i.defaultValue.split(";");
            let searchVal_ = [];
            Val_.map((i) => {
              let val = i.split(",");
              searchVal_.push(val[val.length - 1]);
            });
            this.subData[i.id] = searchVal_.join(";");
            this.pageData[i.index] = searchVal_.map((j) => {
              return this.getParentIdListByPid(i.listEntrie, j);
            });
          }
          if (i.listType == 1 || !i.listType) {
            this.subData[i.id] = i.defaultValue;
            this.pageData[i.index] = i.defaultValue.split(";");
          }
        } else if (i.uiType == 10) {
          this.subData[i.id] = parseFloat(i.defaultValue).toFixed(2);
          this.pageData[i.index] = parseFloat(i.defaultValue).toFixed(2);
        } else {
          this.subData[i.id] = i.defaultValue;
          this.pageData[i.index] = i.defaultValue;
        }
        //console.log(this.columnInfo);
        //const e = this.columnInfo.find(item =>item.index == i.index).id;
        // this.subData[e] = this.pageData[i.index];
        //console.log(this.subData);
      });
    },

    upData() {
      this.$emit("update:change", this.subData);
      this.$emit("getData", this.value);

      let m = this.subData
      console.log(m);
      for (const key in this.reqList) {
        //console.log();
        let e = this.reqList[key];
        if (!Boolean(m[e])) {
          console.log(e);
          this.isReq = false;
          break;
        } else {
          this.isReq = true;
        }
      }
      // console.log(this.isReq);
      this.$emit("update:checkReq", this.isReq);
    },
    getCalendar() {
      this.$http.get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear()).then(
        res => {
          console.log(res);
          this.calendarList = res.data.object;
          this.cList = this.calendarList.map(i => i.exceptionDate.split('T')[0]);
          console.log(this.cList);
        }
      )
    },
    calendarDate(time) {

      if (this.cList.includes(this.getLocalTime(time.getTime()))) {
        if ([0, 6].includes(time.getDay())) {
          return 'date-pick-workday'
        } else {
          return 'date-pick-holiday'
        }
      }
      if ([0, 6].includes(time.getDay()) && !this.cList.includes(this.getLocalTime(time.getTime()))) {
        return 'date-pick-holiday'
      }

    },
  },
  mounted() { },
  created() {
    this.getColumn();
    !this.pageIndex && this.getCalendar();
  },
  watch: {
    reset() {
      this.pageData = [];
      this.subData = {};
      this.getColumn();
    },
  },
};
</script>

<style>
ol,
ul {
  list-style: none;
}

.del .el-form-item__label {
  text-decoration: #f56c6c line-through;
  /* color: red; */
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}

.date-pick-workday span {
  /* color: #fff;
  background: #f56c6c; */
  /* border-radius: 12px; */
}

.date-pick-holiday span {
  color: #fff;
  background: #a0cfff;
  border-radius: 8% !important;
}
</style>

<style scoped>
/* .active {
  width: 48%;
  float: left;
}
.active2 {
  text-align: left;
  width: 48%;
  display: block;
} */

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}
</style>
